import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { csrfToken } from '@/lib/csrf';

export function NoActiveParticipation({ userName }: { userName: string }) {
  const [isPending, setIsPending] = useState(false);

  const handleLogout = async () => {
    setIsPending(true);
    try {
      await fetch('/api/auth/sign-out', {
        method: 'POST',
        headers: { 'X-CSRF-Token': csrfToken() },
      });
    } finally {
      // Hard reload so the server re-evaluates the (now empty) session.
      window.location.href = '/login';
    }
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-background px-4 text-center">
      <div className="max-w-md space-y-3">
        <h1 className="font-bold text-2xl text-primary sm:text-3xl">
          No tienes una participación activa
        </h1>
        <p className="font-mono text-primary/70 text-sm">
          La cuenta conectada (<span className="font-bold">{userName}</span>) no
          tiene una postulación aprobada para el evento actual. Si crees que es
          un error, contacta a los organizadores.
        </p>
      </div>
      <Button onClick={handleLogout} disabled={isPending} variant="outline">
        {isPending ? 'Cerrando sesión…' : 'Cerrar sesión'}
      </Button>
    </div>
  );
}
